import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=66aeb612&scoped=true&"
import script from "./LogoutDialog.vue?vue&type=script&lang=ts&"
export * from "./LogoutDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LogoutDialog.vue?vue&type=style&index=0&id=66aeb612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aeb612",
  null
  
)

export default component.exports